import { useGameStore } from '../../game/store/GameStore'
import { IPlaceOrderApi } from '../api/placeOrderApi'
import { ApiError, autoPlayService, ErrorType, Ga4EventType, ga4Info, GodziDropResultType, setErrorPopupData, useChipSetStore, useEndGameStore, usePlayerStore, useTurboStore, useVoucherStore } from '@slot-nx/core'
import { BetOptionType, getPayStake } from '../utils/stakeUtils'
import { PlaceOrderRequest } from '../api/PlaceOrderRequest'
import { useGodziDropStore } from '../../godzi/store/godziDropStore'

export class PlaceOrderService {
  private _api: IPlaceOrderApi
  constructor(api: IPlaceOrderApi) {
    this._api = api
  }

  async placeOrder() {
    const isVoucher = useGameStore.getState().isVoucher()
    const placeOrderReq = generatePlaceRequest(isVoucher)

    try {
      const res = await this._api.placeOrder(placeOrderReq)
      // balance = -1 代表後端延遲結算（有 FG/BG 或有贏分），動畫播完後由 endGameService 結算
      useEndGameStore.setState({ refNo: res.refNo, isSettled: res.balance !== -1 })
      usePlayerStore.setState({ balance: res.placedBalance, lastSettledBalance: res.balance })
      recordPlaceBetGa4Event(placeOrderReq.betOptionType)
      const gameResult = res.gameResult

      useGodziDropStore.setState({
        effectiveStake: res.godziDropResult.effectiveStake,
        type: res.godziDropResult.type as GodziDropResultType,
        prize: res.godziDropResult.prize,
        payout: res.godziDropResult.payout,
        freeSpinCount: res.godziDropResult.freeSpinCount,
        gameResultList: res.godziDropResult.gameResultList,
      })
      if (isVoucher) {
        useVoucherStore.setState(state => ({
          tempSlotVoucher: res.slotVoucherSummary,
          remainSpin: state.remainSpin - 1,
        }))
        if (!useVoucherStore.getState().remainSpin) autoPlayService.cancel()
      }
      // session 記帳：下單成功當下就記注額（voucher 局同樣計入 session 總注額）。
      // 派彩另外在 onSpinning / onFreeOnce 記，不能掛在 init game——autoplay 會跳過該狀態。
      usePlayerStore.getState().updateSessionWinLose(placeOrderReq.orderStake, 0)
      // betOptionType 在這裡就被重設，win bar 的小額派彩判斷要用實際下注金額，
      // 所以先存下來供後續比較使用
      useGameStore.setState({
        betOptionType: BetOptionType.MainGame,
        lastPayStake: placeOrderReq.orderStake,
      })
      return gameResult
    }
    catch (e) {
      useGameStore.setState({ betOptionType: BetOptionType.MainGame, isShowSpinLoading: false })
      autoPlayService.cancel()
      if (e instanceof ApiError) {
        setErrorPopupData(e.type)
      }
      else {
        setErrorPopupData(ErrorType.SystemError)
      }
      throw e
    }
  }
}

function generatePlaceRequest(isVoucher: boolean): PlaceOrderRequest {
  if (isVoucher) {
    const { fixedStake, currentVoucherId } = useVoucherStore.getState()
    const betOptionType = BetOptionType.MainGame
    return {
      stake: fixedStake,
      orderStake: getPayStake(fixedStake, betOptionType),
      betOptionType,
      voucherId: currentVoucherId,
      isExtra: false,
    }
  }
  else {
    const stake = useChipSetStore.getState().computed.currentStake
    const betOptionType = useGameStore.getState().betOptionType
    return {
      stake,
      orderStake: getPayStake(stake, betOptionType),
      betOptionType,
      voucherId: '',
      isExtra: false,
    }
  }
}

function recordPlaceBetGa4Event(betOptionType: BetOptionType) {
  const isTurbo = useTurboStore.getState().isTurbo
  if (betOptionType === BetOptionType.MainGame) {
    ga4Info.recordPlaceMainBet()
  }
  else {
    ga4Info.recordPlaceBonusBet()
  }
  if (isTurbo) ga4Info.addEvent(Ga4EventType.spin_with_speed)
}
